import React, { PureComponent } from 'react';
import {
  Spinner, Button,
} from 'reactstrap';
import PropTypes from 'prop-types';
import CloudDownloadIcon from 'mdi-react/CloudDownloadIcon';

const canPreview = ['image/jpeg', 'image/png', 'application/pdf', 'text/plain', 'image/svg+xml'];

class ModalFileContent extends PureComponent {
  render() {
    const {
      fileInfo, saveFile, isLoadedFileContent, setLoadedFileContent,
    } = this.props;
    if (!canPreview.includes(fileInfo.metadata.contentType)) {
      return (
        <div className="file-container flex-column">
          <div>
            <CloudDownloadIcon />
            <h5 className="text-white">
              Téléchargement du fichier en cours...
            </h5>
          </div>
          <div>
            <Button onClick={e => saveFile(e, fileInfo)} color="link" className="mt-40">
              Si le téléchargement ne démarre pas automatiquement, cliquez ici
            </Button>
          </div>
          <div className="fullHeight">
            { !isLoadedFileContent ? <Spinner color="primary" role="status" aria-hidden="true" /> : <div /> }
            <iframe title={fileInfo.name} onLoad={() => setLoadedFileContent(true)} className="docViewer" src={fileInfo.url} />
          </div>
        </div>
      );
    }
    if (['image/jpeg', 'image/png', 'image/svg+xml'].includes(fileInfo.metadata.contentType)) {
      return (
        <div className="file-container">
          { !isLoadedFileContent ? <Spinner color="primary" role="status" aria-hidden="true" /> : <div /> }
          <img src={fileInfo.url} onLoad={() => setLoadedFileContent(true)} alt="img" />
        </div>
      );
    }
    if (['text/plain'].includes(fileInfo.metadata.contentType)) {
      return (
        <div className="white-background fullHeight">
          { !isLoadedFileContent ? <Spinner color="primary" role="status" aria-hidden="true" /> : <div /> }
          <iframe title={fileInfo.name} onLoad={() => setLoadedFileContent(true)} className="docViewer" src={fileInfo.url} />
        </div>
      );
    }
    console.log('we here, probably pdf');
    return (
      <div className="white-background fullHeight">
        { !isLoadedFileContent ? <Spinner color="primary" role="status" aria-hidden="true" /> : <div /> }
        <iframe ref={this.contentRef} title={fileInfo.name} onLoad={() => setLoadedFileContent(true)} className="docViewer" src={fileInfo.url} />
      </div>
    );
  }
}

ModalFileContent.propTypes = {
  fileInfo: PropTypes.shape({}).isRequired,
  isLoadedFileContent: PropTypes.bool.isRequired,
  saveFile: PropTypes.func.isRequired,
  setLoadedFileContent: PropTypes.func.isRequired,
};
export default ModalFileContent;
